/* eslint-disable no-whitespace-before-property */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useContext, useRef } from "react";
import Axios from "axios";
import StateContext from "../StateContext";
import { green } from "@material-ui/core/colors";
import Page from "../Components/Page";
import IconButton from '@mui/material/IconButton';

import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";

import DispatchContext from "../DispatchContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import WalletMob from "../Components/WalletMob";
import GoSellElementsTrans from "./GoSell";
import clsx from "clsx";
import { Button } from "@material-ui/core";

import LoaderAnimation from "../Components/LoaderAnimation";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import trash from "../Assets/images/trash.svg";
import dollar from "../Assets/images/dollar.svg";
import gift from "../Assets/images/gift.svg";
import masterCard from "../Assets/images/masterCard.svg";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { withTranslation, useTranslation, } from "react-i18next";

// Cookies functions
import { erase, getCookie } from "../Functions/cookieFunction";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: "700px",
    // justifyContent: 'center',
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
// // screen size work for component change
// function HandleWidth() {
//   const [width, setWidth] = useState();
//   useEffect(() => {
//     const handleSize = () => {
//       setWidth(window.innerWidth);
//     };
//     window.addEventListener("resize", handleSize);
//   }, []);
//   return width;
// }

function Wallet(props) {
  const appState = useContext(StateContext);
  const { t } = useTranslation();
  const appDispatch = useContext(DispatchContext);
  const classes = useStyles();
  const childRef = useRef();
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const history = useHistory();
  const [paymentValue, setPaymentValue] = useState(1);
  const [, setCardResponse] = useState([]);
  const [, setCardStatus] = useState("");
  const [inpValue, setInpValue] = useState(1);
  const [seeMore, setSeeMore] = useState(1);
  const [, setAmount] = useState("");
  const [success] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [tapId, setTapId] = useState();
  const [payWithValue, setPayWithValue] = useState();
  const [saveCard, setSaveCard] = useState(false);
  const [loading] = useState(false);



  const getSaveCards = async () => {
    var credToken = getCookie("tokenAuth");
    if (credToken !== "" && credToken !== null) {
      try {
        const newReq = await Axios.get(
          `${process.env.REACT_APP_API_URL}customer/get_card`,
          {
            headers: {
              Authorization: `Bearer ${getCookie("tokenAuth")}`,
            },
          }
        );

        if (newReq.data.success == true) {
          appDispatch({ type: "updatedCardList", cardList: newReq.data.data });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          appDispatch({
            type: "SHOW_ALERT",
            alertType: "success",
            message: `${newReq.data.message}`,
          });
        }

        else {
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          // appDispatch({
          //   type: "SHOW_ALERT",
          //   alertType: "success",
          //   message: `${newReq.data.message}`,
          // });
        }
        // // console.log(cardData)
      } catch (e) {
        Promise.reject(e);
        erase("tokenAuth");
        erase("Profile");
        appDispatch({ type: "logout" });
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    }
  };



  useEffect(() => {
    getSaveCards();
  }, []);






  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  const handlePaymentChange = (e) => {
    // console.log("sdkjfklsjdfkl");

    setPayWithValue(e.target.value);

    if (e.target.value == "card") {
      setSaveCard(false);
    }
  };
  const handlePaymentValue = (e) => {
    setPaymentValue(parseFloat(e.target.value));
  };

  // useEffect(() => {
  //   const queryString = window.location.search;
  //   const urlParams = new URLSearchParams(queryString);
  //   setTapId(urlParams.get("tap_id"));
  //   // console.log(appState.cardList, "cardlists");
  // }, []);

  useEffect(() => {
    setInpValue(paymentValue);
  }, [paymentValue]);




  const handleCard = () => {
    childRef.current.submitRequest();
  };

  if (!appState.loggedIn) {
    history.push("/");
  }
  const topUp = async () => {
    appDispatch({
      type: "Set_FreezScreen",
      freezScreen: true,
    });
    const token = {
      headers: {
        Authorization: `Bearer ${appState.token}`,
      },
    };
    if (payWithValue == "knet" || payWithValue == "card") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}customer/topup`,
          {
            amount: inpValue,
            payment_source: payWithValue,
            token: tapId ? tapId : null
          },
          token
        );
        if (response.data.success == true) {
          const win = window.open(`${response.data.data.url}`, "_self");
          win.focus();
        } else if (response.data.success == false) {
          setAlertMessage({
            open: true,
            message: `${response.data.message}:  ${response.data.data}`,
            alertSuccess: false,
          });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      } catch (e) {
        // if(e.response.status == 401){
        //   setAlertMessage({
        //     open: true,
        //     message: "Please Login Again.",
        //     alertSuccess: false,
        //   });
        //   handleLogout();
        // }
        // else{
        //   setAlertMessage({
        //     open: true,
        //     message: e.response.message,
        //     alertSuccess: false,
        //   });
        // }
        Promise.reject(e);

        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    } else {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}customer/topup`,
          {
            amount: inpValue,
            payment_source: "save_card",
            card_id: payWithValue,
          },
          token
        );
        if (response.data.success == true) {
          const win = window.open(`${response.data.data.url}`, "_self");
          win.focus();
        } else if (response.data.success == false) {
          setAlertMessage({
            open: true,
            message: `${response.data.message}:  ${response.data.data}`,
            alertSuccess: false,
          });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
        }
      } catch (e) {
        Promise.reject(e);

        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      payWithValue != undefined &&
      payWithValue != "" &&
      payWithValue != null
    ) {
      if (payWithValue == "card") {
        if (tapId != undefined && tapId != "" && tapId != null) {
          topUp();
        } else {
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: true,
          });
          childRef.current.submitRequest();
        }
      } else {
        topUp();
      }
    } else {
      setAlertMessage({
        open: true,
        message: "Please select any payment method!",
        alertSuccess: false,
      });
    }
  };

  useEffect(() => {
    if (tapId != "" && tapId != undefined) {
      topUp();
    }
  }, [tapId]);

  const handleManageCard = () => {
    setSaveCard(!saveCard);
    setPayWithValue("saveCard");
  };
  const handlChangeView = () => {
    if (appState.cardList.length > seeMore) {
      setSeeMore(seeMore + 1);
    } else {
      setSeeMore(1);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setAlertMessage({ open: false, message: "", alertSuccess: false });
    }, 8000);
  }, [alertMessage.open]);

  const handleDeleteCard = async (id) => {
    appDispatch({
      type: "Set_FreezScreen",
      freezScreen: true,
    });
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}customer/delete_card`,
        {
          card_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          }
        },
      );
      if (response.data.success == true) {

        getSaveCards()
        appDispatch({
          type: "SHOW_ALERT",
          alertType: "success",
          message: `${response.data.message}`,
        });
      } else if (response.data.success == false) {

        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    } catch (e) {
      Promise.reject(e);

      appDispatch({
        type: "Set_FreezScreen",
        freezScreen: false,
      });
    }
  }




  if (loading)
    return (
      <div className={classes.root}>
        {" "}
        <LoaderAnimation />{" "}
      </div>
    );
  return (
    <>
      {true ? (
        <Page title="Wallet">
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alertMessage.open}
            className={
              alertMessage.alertSuccess ? "success-alert" : "danger-alert"
            }
          >
            {alertMessage.alertSuccess ? (
              <Alert severity="success">{alertMessage.message}</Alert>
            ) : (
              <Alert severity="error">{alertMessage.message}</Alert>
            )}
          </Snackbar>
          {/* {minDesktop ? */}
          <div
            id="wallet-section"
            className={`${appState.langValue === "ar" ? "directionRtl" : ""} ${buttonLoading ? "disableClass" : ""}`}
          >
            {/* <Navbar handleChange={handleChange} /> */}
            {/* <Banner message_primary="Hello," message_secondary={appState.profile.name} other_message="Welcome to Our Website" /> */}

            <div className="container-fluid walletParent">
              <div className="row d-flex justify-content-center">
                <div className="bgWhite col-md-6 px-0">
                  <div className="col-md-12 bgWhite">
                    <div id="header">
                      <div
                        className="d-flex align-items-center py-4"
                      >
                        <IconButton onClick={() => history.push("/dashboard")} size="large" className="p-0">   {appState.langValue === "ar"
                          ? <ArrowForwardIcon />
                          : <ArrowBackIcon className="px-1" />}</IconButton>

                        <div
                          className="mt-2  w-100 d-flex justify-content-center align-items-center flex-column"
                        >
                          <h1 className="familyPoppins600 mb-0 textBlack">{t("wallet.wallet")}</h1>


                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 bgWhite">
                    <div className="mb-3 row walletCards">
                      <div className={`col-6 px-3 ${appState.langValue === "ar"
                        ? "pl-3"
                        : "pr-3"
                        }`} >  <div className=" py-3 px-4 walletBalanceCard">
                          <IconButton className="iconBtn mb-3"><img src={dollar} alt="" /></IconButton>

                          <p className="familyPoppins500 mb-0 textBlack">{t("wallet.balance")}</p>
                          <p className="familyPoppins600 mb-0 textBlack">   {appState.profile.walletAmount

                            ? parseFloat(appState.profile.walletAmount)
                            : "0 "}{" "} {t("KWD")}</p>
                        </div></div>

                      <div className={`col-6 px-3 ${appState.langValue === "ar"
                        ? "pr-3"
                        : "pl-3"
                        }`} ><div className="py-3 px-4 walletCashBackCard">  <IconButton className="iconBtn mb-3 "><img src={gift} alt="" /></IconButton>

                          <p className="familyPoppins500 mb-0 textBlack">{t("wallet.cashback")}</p>
                          <p className="familyPoppins600 mb-0 textBlack">0.00 {t("KWD")}</p></div></div>


                    </div>
                  </div>


                  <div className="bgWhite">
                    <div className="col-md-12 ">
                      <div className="row m-0 align-items-center WalletRow">
                        <div className="col-md-12 px-0">
                          <h5 className="d-flex">
                            <span className="familyPoppins600 textBlack"> {t("invoice.Amount")}</span>
                          </h5>
                        </div>
                        <div className="col-md-12 px-0  pt-2 pb-3">
                          <div className="WalletInfomration direction-ltr walletInputLarge">
                            {/* <TextField placeholder="0.0" onChange={handleInpValue} value={parseFloat(inpValue)} type="number" /> */}
                            <OutlinedInput
                              id="standard-adornment-weight"
                              onChange={(e) => handlePaymentValue(e)}
                              value={inpValue}
                              type="number"
                              className="border-0 w-100  amount-field text-center  "
                              endAdornment={
                                <InputAdornment position="end" className="text-muted">
                                  {t("KWD")}
                                </InputAdornment>
                              }
                            />
                          </div>
                          {/* <span className="text-secondary"><strong>{t("KWD")}</strong></span> */}
                        </div>
                      </div>
                    </div>
                    <div className="selectPayment">
                      <div
                        className="row m-0 selectPaymentRow selectPaymentRowWallet"
                        onChange={(e) => handlePaymentValue(e)}
                      >
                        <div className="col-4 direction-ltr">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="10"
                              name="selectPayment"
                              id="paymentTwenty"
                            />
                            <label htmlFor="paymentTwenty">
                              <span>
                                <strong>10.00 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-4 direction-ltr">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="20"
                              name="selectPayment"
                              id="paymentThirty"
                            />
                            <label htmlFor="paymentThirty">
                              <span>
                                <strong className="payment">20.00 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-4 direction-ltr">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="30"
                              name="selectPayment"
                              id="paymentFourty"
                            />
                            <label htmlFor="paymentFourty">
                              <span>
                                <strong>30.00 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-4 direction-ltr">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="40"
                              name="selectPayment"
                              id="paymentFifty"
                            />
                            <label htmlFor="paymentFifty">
                              <span>
                                <strong>40.00 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-4 direction-ltr">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="50"
                              name="selectPayment"
                              id="paymentSixty"
                            />
                            <label htmlFor="paymentSixty">
                              <span>
                                <strong>50.00 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                        <div className="col-4 direction-ltr">
                          <div className="paymentContainer">
                            <input
                              type="radio"
                              value="60"
                              name="selectPayment"
                              id="paymentSeventy"
                            />
                            <label htmlFor="paymentSeventy">
                              <span>
                                <strong>60.00 {t("KWD")}</strong>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row m-0 mt-4">
                      <div className="payWith col-md-12 px-1">
                        <span className="d-flex align-items-center justify-content-between">
                          <h5 className="px-3 d-flex textBlack familyPoppins600">{t("pay.pay-with")}</h5>
                          <Button
                            variant="contained"
                            color="primary"
                            className={`${buttonClassname} familyPoppins500 manageCardBtn`}
                            // disabled={buttonLoading}
                            onClick={handleManageCard}
                          >
                            {t("invoice.Manage-Cards")} {appState.langValue === "ar"
                              ? <KeyboardArrowLeftIcon />
                              : <KeyboardArrowRightIcon />}
                          </Button>
                        </span>

                        {saveCard ? (
                          <>
                            <GoSellElementsTrans
                              setTapId={setTapId}
                              ref={childRef}
                              setCardStatus={setCardStatus}
                              payWithValue={'save_card'}
                              setCardResponse={setCardResponse}
                              setAlertMessage={setAlertMessage}
                              setAmount={setAmount}
                              setButtonLoading={setButtonLoading}
                              inpValue={inpValue}
                              setSaveCard={setSaveCard}
                            />
                          <div
                              className={`${classes.wrapper} w-100 d-flex justify-content-center`}
                            >
                              <Button
                                variant="contained"
                                // disabled={inpValue < 1.5}
                                onClick={handleCard}
                                color="primary"
                                className={`${buttonClassname} bgE34F53 w-50 textWhite familyPoppins600  py-3 d-flex align-items-center justify-content-center`}
                                disabled={buttonLoading}
                              >
                                {buttonLoading ? "Rendring" : t("wallet.add-card")}
                              </Button>
                              {buttonLoading && (
                                <CircularProgress
                                  size={24}
                                  className={classes.buttonProgress}
                                />
                              )}
                            </div>

                          </>
                        ) : (
                          ""
                        )}

                        <div
                          className="row m-0 mt-4"
                        >

                          {appState.cardList != null
                            ? appState.cardList.slice(0, seeMore).map((val, ind) => {
                              return (
                                <div className="col-12" key={ind}>
                                  <div className="paymentContainer">

                                    <input
                                      type="radio"
                                      onChange={(e) => handlePaymentChange(e)}

                                      checked={payWithValue == val.id}
                                      value={val.id}
                                      name="paymentMethod"
                                      id={`paymentSaveCard-${val.id}`}
                                    />
                                    <label htmlFor={`paymentSaveCard-${val.id}`}>
                                      <div className="payment-method d-flex justify-content-between">
                                        <div className="d-flex">   <span className="px-4">
                                          <img
                                            src={masterCard}
                                            alt=""
                                            width="30"
                                          />
                                        </span>
                                          <span className="px-4 ">
                                            <h4 className="mt-2 text-capitalize">
                                              {val.type}
                                              <p className="text-muted">
                                                {" "}
                                                **** **** **** {val.last_four}
                                              </p>
                                            </h4>
                                          </span></div>

                                        <IconButton onClick={() => handleDeleteCard(val.id)} className="mx-2" size="large" aria-label="delete">
                                          <img src={trash} alt="delete" />
                                        </IconButton>

                                      </div>


                                    </label>
                                  </div>
                                </div>
                              );
                            })
                            : ""}
                          {/* button for view more save cards */}
                          <div className="col-12 d-flex justify-content-end mb-2">
                            {appState.cardList.length > 1 && <Button
                              className="text-capitalize"
                              variant="text"
                              onClick={handlChangeView}
                            >
                              {seeMore < appState.cardList.length
                                ? "See More"
                                : "See Less"}
                            </Button>}
                          </div>

                          <div className="col-12">
                            <div className="paymentContainer">
                              <input
                                type="radio"
                                onChange={(e) => handlePaymentChange(e)}
                                checked={payWithValue == "knet"}
                                id="paymentKnet"
                                value="knet"
                                name="paymentMethod"
                              />
                              <label htmlFor="paymentKnet">
                                <div className="payment-method">
                                  <span className="px-4">
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL}Knet.png`}
                                      alt=""
                                      width="30"
                                    />
                                  </span>
                                  <span className="px-4">
                                    <h4 className="mt-2">{t("pay.knet")}</h4>
                                  </span>
                                </div>
                              </label>
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="paymentContainer">
                              <input
                                type="radio"
                                onChange={(e) => handlePaymentChange(e)}
                                checked={payWithValue == "card"}
                                id="paymentCard"
                                value="card"
                                name="paymentMethod"
                              />
                              <label htmlFor="paymentCard">
                                <div className="payment-method">
                                  <span className="px-4">
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL}masterVisa.png`}
                                      alt=""
                                      width="30"
                                    />
                                  </span>
                                  <span className="px-4">
                                    <h4 className="mt-2">{t("pay.creadit")}</h4>
                                  </span>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {payWithValue == "card" ? (
                        <div className="col-12">
                          <GoSellElementsTrans
                            ref={childRef}
                            inpValue={inpValue}
                            setTapId={setTapId}
                            payWithValue={payWithValue}
                            setButtonLoading={setButtonLoading}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="text-center col-12 my-4">
                        <Button
                          variant="contained"
                          disabled={buttonLoading}
                          // type="submit"
                          onClick={handleSubmit}
                          className="col-12 py-3 bgE34F53 textWhite familyPoppins600"
                        >
                          {buttonLoading ? "Processing" : t("invoice.Confirm-&-Pay")}
                        </Button>
                        {buttonLoading && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Page>
      ) : (
        <WalletMob />
      )}
    </>
  );
}

export default withTranslation()(Wallet);

